import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import millify from 'millify'
import profileMaleSVG from '../../assets/images/profile-male.svg'
import { getProfile } from '../../services/ideas.service'

export const ProfileCard = () => {
    const user = useSelector(state => state.user)
    const [totalIdeas, setTotalIdeas] = useState(0)
    const [totalLikes, setTotalLikes] = useState(0)
    const [totalApproved, setTotalApproved] = useState(0)

    useEffect(() => {
        const getProfileData = async () => {
            const { status, data } = await getProfile()
            if (status == 200) {
                setTotalIdeas(data.totalIdeas)
                setTotalLikes(data.totalLikes)
                setTotalApproved(data.totalApproved)
            }
        }
        getProfileData()
    }, [])
    return (
        <div className="card card-profile">
            <div className="card-body">
                <div className="profile-image-wrapper mt-1">
                <div className="starshot-ring"><div className="avatar"><div className="text-icon font-lato font-32 w-50p h-50p">{user?.empName?.[0]}</div></div></div>
                </div>
                <h3>{user?.empName}</h3>
                <h6 className="font-lato star-orange font-12">@{user?.empEmail && user?.empEmail?.split("@")?.[0]}</h6>
                <hr className="my-1 mt-4" />
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 className="mb-0 font-weight-600">{millify(totalIdeas)}</h3>
                        <p className="mb-0 opacity-50 font-weight-500 font-11 font-lato">
                            Ideas
                        </p>
                    </div>
                    <div>
                        <h3 className="mb-0">{millify(totalLikes)}</h3>
                        <p className="mb-0 opacity-50 font-weight-500 font-11 font-lato">
                            Up Votes
                        </p>
                    </div>
                    <div>
                        <h3 className="mb-0">{millify(totalApproved)}</h3>
                        <p className="mb-0 opacity-50 font-weight-500 font-11 font-lato">
                            Approved
                        </p>
                    </div>
                </div>
            </div>
        </div>

    )
}